import { useApp } from 'context/AppContext';
import { useState, useEffect } from 'react';
import { getIsPurchase, getLoginCount } from 'utils/auth';
import iosShareIcon from 'assets/svg/ios-share.svg';
import installIcon from 'assets/svg/install.svg';
import { Banner, Popup, Description, Tap, Button, NoThanks, Title, Section } from './Styles';
import { Icon } from 'styles/AppStyles';
import { currentContentConfig } from 'utils/handleCurrentContentConfig';

const PWA = ({ isIos, handlePwaButton }) => {
  const [isPopup, setIsPopup] = useState(false);
  const { state, openModal } = useApp();
  const { isNewSession } = state;

  const loginCount = getLoginCount();
  const isPurchase = getIsPurchase();

  useEffect(() => {
    if (isPurchase && isNewSession && loginCount > 0 && loginCount <= 3) {
      isIos ? openModal({ modal: 'pwa' }) : setIsPopup(true);
    }
  }, []);

  return isPopup ? (
    <Popup>
      <Section>
        <Icon src={currentContentConfig.icon_512x512} width={90} />
        <Title>Install the store</Title>
        <Description>Install this web page to your home screen for a better experience</Description>
      </Section>
      <Section>
        <Button onClick={handlePwaButton}>
          Install <Icon src={installIcon} width={15} />
        </Button>
        <NoThanks onClick={() => setIsPopup(false)}>No Thanks</NoThanks>
      </Section>
    </Popup>
  ) : (
    <Banner>
      <Icon src={currentContentConfig.icon_512x512} width={80} />
      <Description>Install this web page to your home screen for a better experience</Description>
      {isIos ? (
        <Tap>
          Tap <Icon src={iosShareIcon} width={20} /> then 'Add to home screen'
        </Tap>
      ) : (
        <Button onClick={handlePwaButton}>
          Install <Icon src={installIcon} width={15} />
        </Button>
      )}
    </Banner>
  );
};

export default PWA;
